/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const JiffyInfoPspR = t.interface({});

// optional attributes
const JiffyInfoPspO = t.partial({
  codiceEsito: t.string,

  numeroTelefonicoCriptato: t.string,

  numeroTelefonicoOffuscato: t.string,

  primitiva: t.string
});

export const JiffyInfoPsp = t.intersection(
  [JiffyInfoPspR, JiffyInfoPspO],
  "JiffyInfoPsp"
);

export type JiffyInfoPsp = t.TypeOf<typeof JiffyInfoPsp>;
